class ProductInformationSelect extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {


    this.checkDynamicSelectWrapper();
    this.initUrlParams();
    this.initQuestionDescriptions();
  }

  checkDynamicSelectWrapper() {
    const dynamicSelectWrapper = this.querySelector('.dynamic-select_wrapper');

    if (dynamicSelectWrapper) {
      this.initDynamicSelect();
    } else {
      this.observeDynamicSelectWrapper();
    }
  }

  observeDynamicSelectWrapper() {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const dynamicSelectWrapper = this.querySelector('.dynamic-select_wrapper');

          if (dynamicSelectWrapper) {
            this.initDynamicSelect();
            observer.disconnect();
            break;
          }
        }
      }
    });

    observer.observe(this, { childList: true, subtree: true });
  }

  initDynamicSelect() {
    const dynamicSelectTitle = this.querySelector('.dynamic-select-title');
    const ul = this.querySelector('.dynamic-select ul');
    const selectTitleWrapper = this.querySelector('.select-title_wrapper');
    const productInformationSelects = this.querySelectorAll('.js-product-information-select');

    if (!dynamicSelectTitle || !ul || !selectTitleWrapper) {
      return;
    }

    selectTitleWrapper.addEventListener('click', () => {
      ul.classList.toggle('open');
      dynamicSelectTitle.classList.toggle('active');
    });

    productInformationSelects.forEach((element, index) => {
      const title = element.querySelector('.how-to-use__main-section--content_title')?.textContent.trim();
      const sku = element.getAttribute('data-sku');

      const li = document.createElement('li');
      li.textContent = title;
      li.dataset.sku = sku;
      ul.appendChild(li);

      li.addEventListener('click', () => {
        productInformationSelects.forEach((el) => el.classList.remove('active'));
        this.querySelector(`.js-product-information-select[data-sku="${sku}"]`).classList.add('active');
        dynamicSelectTitle.textContent = title;
        ul.classList.remove('open');
        dynamicSelectTitle.classList.remove('active');

      });

      if (index === 0) {
        dynamicSelectTitle.textContent = title;
        element.classList.add('active');
        this.openFirstDescription();
      }
    });
  }

  getUrlParams() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);

    params['dd'] = urlParams.get('dd');

    params['line_items'] = [];
    urlParams.forEach((value, key) => {
      if (key.startsWith('line_items[') || key === 'line_items') {
        params['line_items'].push(value);
      }
    });

    return params;
  }

  initUrlParams() {
    const params = this.getUrlParams();

    if (!params.line_items.length) {
      return;
    }

    const hasDynamicSelect = !!this.querySelector('.dynamic-select_wrapper');
    if (!hasDynamicSelect) {
      const normalizedSkus = params.line_items.map((s) => s.toUpperCase());
      this.querySelectorAll('[data-sku]').forEach((card) => {
        if (normalizedSkus.includes(card.getAttribute('data-sku').toUpperCase())) {
          card.classList.add('active');
        }
      });
    }

    if (params.dd === 'yes') {

      const directionsBlock = this.querySelector('.questions_list_double_dose_JC')?.parentElement;
      if (directionsBlock) {
        this.querySelector('.questions_list_double_dose_JC').style.display = 'block';

        directionsBlock
          .querySelectorAll('.questions-list__description:not(.questions-list__description--dd)')
          .forEach((element) => (element.style.display = 'none'));

        directionsBlock
          .querySelectorAll('.how-to-use__main-section--img-item:not(.how-to-use__main-section--img-item-dd)')
          .forEach((element) => (element.style.display = 'none'));
      }
    }
  }


  initQuestionDescriptions() {
    const titles = this.querySelectorAll('.js-questions-list__title');
  }

  openFirstDescription() {

    const firstDescription = this.querySelector('.js-questions-list__description');

    if (firstDescription) {
      const firstTitle = firstDescription.previousElementSibling;

      if (firstTitle && firstTitle.classList.contains('js-questions-list__title')) {
        firstDescription.classList.add('open');
        firstDescription.style.maxHeight = firstDescription.scrollHeight + 'px';
        firstTitle.classList.add('opened');
      }
    }
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('product-information-select', ProductInformationSelect);
